import React from "react";
import Events from "../Events";
import { DiaryFilterTypes } from '../../../types/index';

interface OwnTypes {
    filterData:Array<DiaryFilterTypes>, 
    title:string, 
    item:Array<any>,
    type:string, 
    itemNames:Array<string>,
    callback: () => void
}

const MedicationEvents = ({filterData, title, item, type, itemNames, callback}: OwnTypes) => {
    return(
        <>
        {filterData.length === 0  &&
            <Events title={title} item={item} type={type} itemNames={itemNames} callback={callback} />
        }
        {filterData.length > 0 && item.length > 0 && filterData.find(fd => fd.value === 'reminders') &&
            <Events title={title} item={item} type={type} itemNames={itemNames} callback={callback} />
        }
        </>
    )
}

export default MedicationEvents;